import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {AttributeManifest} from "../models/attributeManifest.model";
import {SetAttributeLocalizationCommand} from "./setAttributeLocalization.command";
import {mintNamespacedUid} from "../utils/uid.utils";

// Ensures every [AttributeHidden] unit attribute the manifest knows about has
// a corresponding Metadata entry in state.unitAttributes. Idempotent — entries
// matched by `id` are left alone; only missing ones are added. Returns false
// when there is nothing to add so the editor's history/dirty state is
// untouched on stable loads. When something is added, the result is a normal
// command in history, so it surfaces as an unsaved change on next save.
export class SyncHiddenUnitAttributesCommand extends CommandBase {
    private readonly manifest: AttributeManifest;

    constructor(manifest: AttributeManifest) {
        super();
        this.manifest = manifest;
    }

    execute(state: RemoteConstantsModel): boolean {
        if (!this.manifest?.UnitAttributes) return false;

        if (state.unitAttributes === undefined) {
            state.unitAttributes = [];
        }

        const existingIds = new Set(state.unitAttributes.map(a => a.id));
        let added = false;

        for (const entry of this.manifest.UnitAttributes) {
            if (!entry.Hidden) continue;
            // The human alias (last id) matches the dropdown convention used
            // by MetadataColumn — the id designers see on a created instance.
            const id = entry.Ids[entry.Ids.length - 1] ?? entry.TypeName;
            if (existingIds.has(id)) continue;

            const uid = mintNamespacedUid('unitattribute', id, state.unitAttributes.map(a => a.uid));
            new SetAttributeLocalizationCommand(uid, id).execute(state);
            state.unitAttributes.push({
                uid,
                id,
                active: true,
                values: {},
                entities: {},
            });
            existingIds.add(id);
            added = true;
        }

        return added;
    }
}
